import { render } from "./AppSubmenu.vue?vue&type=template&id=7a538133&scoped=true"
import script from "./AppSubmenu.vue?vue&type=script&lang=js"
export * from "./AppSubmenu.vue?vue&type=script&lang=js"

import "./AppSubmenu.vue?vue&type=style&index=0&id=7a538133&scoped=true&lang=css"

import exportComponent from "C:\\Work2022\\300_NEVTER\\500_DEVEL\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a538133"]])

export default __exports__